export default "__VITE_ASSET__C46JJx0s__"